export default __webpack_public_path__ + "static/media/search.f34a42f7.svg";